import React from "react";

const CGV: React.FC = () => {
  return (
    <div className="max-w-4xl mx-auto px-4 py-8 text-gray-800">
      <div className="text-center mb-8">
        <h1 className="text-3xl font-bold mb-2">CONDITIONS GÉNÉRALES</h1>
        <p className="text-gray-600">Dernière mise à jour : 13 mars 2025</p>
      </div>

      <div className="mb-8">
        <p className="mb-4">
          Les présentes Conditions Générales de prestations de services clients
          X (&quot;les
          <strong> Conditions Générales</strong>) s&apos;appliquent à toute
          commande de produits alimentaire à livrer ou à emporter, passée par un
          client consommateur non-professionnel (le &quot;Client&quot;,
          &quot;vous&quot;, &quot;votre&quot;, ou &quot;vos&quot;) sur le Site
          Internet www.X.fr ou sur l&apos;application mobile X disponible sous
          les systèmes d&apos;exploitations Android et iOS.
        </p>
        <p className="mb-4">
          Veuillez lire attentivement ces Conditions Générales avant de passer
          une commande sur la Plateforme. En accédant à la Plateforme et en
          passant une commande, vous acceptez sans réserve les dispositions des
          Conditions Générales et toutes conditions générales d&apos;utilisation
          de la Plateforme.
        </p>
        <p className="mb-4">
          X se réserve la possibilité de modifier les Conditions Générales à
          tout moment, les Conditions Générales applicables étant celles en
          vigueur et disponibles sur le site au jour de la passation de commande
          par le Client.
        </p>
        <p>
          Si vous avez des questions au sujet de ces Conditions Générales,
          veuillez nous contacter à l&apos;adresse (adresse mail) avant de
          passer une commande. Si vous n&apos;acceptez pas intégralement ces
          Conditions Générales, n&apos;utilisez pas notre Service.
        </p>
      </div>

      <div className="space-y-8">
        {/* Article 1: Définitions */}
        <div>
          <h2 className="text-2xl font-bold mb-4">1. DÉFINITIONS</h2>
          <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
            <div>
              <p>
                <strong>« Cas de Force Majeure »</strong> a le sens qui lui est
                attribué à l&apos;article 13.7.
              </p>
              <p>
                <strong>« Client »</strong> désigne une personne (consommateur
                personne physique) qui effectue une Commande auprès du
                Restaurant Partenaire par l&apos;intermédiaire de la Plateforme.
              </p>
              <p>
                <strong>« Commande(s) »</strong> désigne une commande effectuée
                par le Client auprès d&apos;un Restaurant Partenaire par
                l&apos;intermédiaire de la Plateforme.
              </p>
              <p>
                <strong>« Commande Définitive »</strong> a le sens qui lui est
                attribué à l&apos;article 0.
              </p>
              <p>
                <strong>« Compte »</strong> désigne le compte client créé par le
                Client au moment de son Inscription sur la Plateforme et qui
                contient ses informations personnelles, conformément à
                l&apos;article 5.2.
              </p>
            </div>
            <div>
              <p>
                <strong>« Conditions Générales »</strong> désigne les présentes
                conditions générales de prestation de services Clients X.
              </p>
              <p>
                <strong>« Délai de Livraison »</strong> a le sens qui lui est
                attribué à l&apos;article 7.1.
              </p>
              <p>
                <strong>« Frais de Livraison »</strong> désigne le coût de la
                prestation de Livraison d&apos;une Commande à un Client réalisée
                par le Partenaire de Livraison qui est facturé en sus du Montant
                de Commande.
              </p>
              <p>
                <strong>« Inscription »</strong> désigne le processus
                d&apos;inscription sur la Plateforme auquel doit procéder le
                Client avant toute passation de Commande, conformément à
                l&apos;article 5.2.
              </p>
            </div>
          </div>
        </div>

        {/* Article 2: Mentions légales */}
        <div>
          <h2 className="text-2xl font-bold mb-4">2. MENTIONS LÉGALES</h2>
          <p className="mb-2">
            <strong>2.1.</strong> Les présentes Conditions Générales sont émises
            par NOM ENTREPRISE, société par actions simplifiée au capital de
            1000 euros, dont le siège social est situé adresse, immatriculée au
            Registre du Commerce et des Société de Ville sous le numéro XXXX,
            numéro de TVA : XX XXXXX (« X », « nous », « notre », « nos »).
          </p>
          <p>
            <strong>2.2.</strong> Vous pouvez nous contacter à l&apos;adresse
            suivante : contact@mail.
          </p>
        </div>

        {/* Article 3: Objet */}
        <div>
          <h2 className="text-2xl font-bold mb-4">3. OBJET</h2>
          <p className="mb-2">
            <strong>3.1.</strong> Les Services proposés de X consistent à vous
            mettre en relation avec nos Restaurants Partenaires qui proposent
            leurs Produits sur la Plateforme et à vous permettre de leur passer
            une Commande. X agit en qualité d&apos;agent pour le compte du
            Restaurant Partenaire qui propose les Produits et prend les
            Commandes que vous passez. Une fois que vous avez passé une
            Commande, votre repas vous sera livré par un Partenaire de Livraison
            partenaire.
          </p>
          <p>
            <strong>3.2.</strong> X agit en qualité de prestataire de services
            pour la fourniture des Services.
          </p>
        </div>

        {/* Article 4: Services fournis par X */}
        <div>
          <h2 className="text-2xl font-bold mb-4">4. SERVICES FOURNIS PAR X</h2>
          <p>X fournit les Services suivants au Client :</p>

          <div className="mt-4">
            <h3 className="text-xl font-semibold mb-2">
              4.1. Services d&apos;accès à la Plateforme
            </h3>
            <p>
              X met à la disposition du Client sa Plateforme afin de mettre en
              relation les Restaurants Partenaires avec le Client. Le rôle de X
              est celui d&apos;intermédiaire pour le compte du Restaurant
              Partenaire.
            </p>
          </div>

          <div className="mt-4">
            <h3 className="text-xl font-semibold mb-2">
              4.2. Services de mise en relation pour la livraison
            </h3>
            <p>
              X met le Restaurant Partenaire en relation avec des Partenaire de
              Livraisons pour la Livraison des Commandes via la Plateforme afin
              que la Commande soit livrée au Client. X agit en qualité de simple
              intermédiaire entre le Restaurant Partenaire et le Partenaire de
              Livraison.
            </p>
          </div>

          <div className="mt-4">
            <h3 className="text-xl font-semibold mb-2">
              4.3. Services de collecte de paiement
            </h3>
            <p>
              X met en place un service de collecte de paiement pour le compte
              du Restaurant Partenaire. A ce titre, X agit en qualité
              d&apos;agent de collecte des paiements réalisés par le Client pour
              les Commandes passées par l&apos;intermédiaire de la Plateforme
              auprès du Restaurant Partenaire.
            </p>
          </div>
        </div>

        {/* Article 5: Utilisation des Services */}
        <div>
          <h2 className="text-2xl font-bold mb-4">
            5. UTILISATION DES SERVICES
          </h2>

          <div className="mt-4">
            <h3 className="text-xl font-semibold mb-2">
              5.1. Utilisation de la Plateforme
            </h3>
            <p className="mb-2">
              <strong>5.1.1.</strong> L&apos;application permettant
              d&apos;accéder à la Plateforme peut être téléchargée et est
              accessible sur la plupart des appareils mobiles modernes disposant
              d&apos;une connexion internet et équipés de systèmes
              d&apos;exploitation répandus tels qu&apos;Android ou iOS.
            </p>
            <p>
              <strong>5.1.2.</strong> Il incombe au Client d&apos;obtenir
              l&apos;accès au réseau internet nécessaire à l&apos;utilisation de
              la Plateforme et de régler tous les tarifs et frais de votre
              prestataire de réseau mobile qui restent à sa charge, y compris
              pour les données différentes à l&apos;utilisation de la
              Plateforme.
            </p>
          </div>

          <div className="mt-4">
            <h3 className="text-xl font-semibold mb-2">
              5.2. Inscription et Compte
            </h3>
            <p className="mb-2">
              <strong>5.2.1.</strong> Avant de pouvoir passer Commande sur la
              Plateforme, vous devez vous enregistrez sur la Plateforme
              (l&apos;« Inscription) et ouvrir un compte X (le « Compte »). Au
              moment de l&apos;Inscription, vous devez avoir plus de dix-huit
              (18) ans et avoir la capacité de jouissance et d&apos;exercice
              pour pouvoir contracter avec les Restaurants Partenaires.
            </p>
            <p className="mb-2">
              <strong>5.2.2.</strong> Lors de votre Inscription, vous devez
              fournir certaines informations personnelles, notamment votre
              numéro de téléphone et votre adresse électronique. Pour effectuer
              une Commande sur la Plateforme, vous devrez indiquer au moins un
              Moyen de Paiement valide (carte de crédit, carte de débit ou tout
              autre Moyen de Paiement accepté).
            </p>
            <p>
              <strong>5.2.3.</strong> Lors de votre Inscription, il vous sera
              demandé de créer un mot de passe. Vous devez garder secret tout
              mot de passe que vous créez, et empêcher d&apos;autres personnes
              d&apos;accéder à votre compte de courrier électronique ou à votre
              téléphone portable.
            </p>
          </div>
        </div>

        {/* Article 6: Commandes */}
        <div>
          <h2 className="text-2xl font-bold mb-4">6. COMMANDES</h2>

          <div className="mt-4">
            <h3 className="text-xl font-semibold mb-2">
              6.1. Passation de Commande
            </h3>
            <p className="mb-2">
              <strong>6.1.1.</strong> Toute Commande via la Plateforme implique
              de suivre les étapes suivantes :
            </p>
            <ul className="list-disc pl-6 mb-4 space-y-2">
              <li>
                Vous entrez votre adresse postale, puis cliquez sur « Voir les
                restaurants »
              </li>
              <li>
                Vous choisissez auprès de quel Restaurant Partenaire vous
                souhaitez commander, puis les Produits que vous souhaitez
                commander ainsi que leur quantité
              </li>
              <li>
                Le panier récapitule les Produits sélectionnés ainsi que leur
                quantité et le Montant de la Commande
              </li>
              <li>
                Si le contenu du panier correspond à ce que vous souhaitez, vous
                pouvez cliquer sur le bouton « Passer commande »
              </li>
              <li>
                Vous choisissez l&apos;option « Livraison » ou « A emporter » et
                renseignez vos informations de paiement
              </li>
            </ul>
            <p className="mb-2">
              <strong>6.1.6.</strong> Le contrat de fourniture de toute Commande
              que vous effectuez par l&apos;intermédiaire de la Plateforme est
              conclu entre vous et le Restaurant Partenaire et n&apos;est conclu
              qu&apos;à compter de l&apos;envoi du Courriel de Confirmation.
            </p>
          </div>

          <div className="mt-4">
            <h3 className="text-xl font-semibold mb-2">
              6.3. Modification ou annulation de Commande
            </h3>
            <p className="mb-2">
              <strong>6.3.1.</strong> Une fois la Commande devenue définitive,
              l&apos;annulation de la Commande n&apos;est plus possible et le
              Prix Total sera facturé.
            </p>
            <p>
              <strong>6.3.2.</strong> Les Commandes passées sur la Plateforme ne
              peuvent faire l&apos;objet du droit de rétractation prévu à
              l&apos;article L. 221-18 et suivants du Code de la consommation
              dans la mesure où elles sont constituées de denrées périssables.
            </p>
          </div>
        </div>

        {/* Article 7: Livraison */}
        <div className="mb-8">
          <h2 className="text-2xl font-bold mb-4">7. LIVRAISON</h2>
          <div className="space-y-4">
            <p>
              <strong>7.1.</strong> X fait ses meilleurs efforts pour
              sélectionner les meilleurs Partenaires de Livraison. Toutefois, il
              est rappelé que les Partenaires de Livraison sont des prestataires
              indépendants. En conséquence, X ne saurait être tenue responsable
              des aléas de livraison comme les conditions de circulation ou les
              conditions météorologiques.
            </p>
            <p>
              <strong>7.2.</strong> X fait ses meilleurs efforts pour garantir
              la Livraison de votre Commande dans le délai de livraison indiqué
              dans le Courriel de Confirmation (le « Délai de Livraison »).
            </p>
            <p>
              <strong>7.3.</strong> Le Délai de Livraison de votre Commande est
              établi en fonction du nombre de Commandes, des conditions
              auxquelles est soumis le Restaurant Partenaire au moment de la
              Commande, et de la distance entre le Restaurant Partenaire et
              l&apos;adresse de livraison.
            </p>
          </div>
        </div>

        {/* Article 8: Prix, Paiement et Offres Promotionnelles */}
        <div className="mb-8">
          <h2 className="text-2xl font-bold mb-4">
            8. PRIX, PAIEMENT ET OFFRES PROMOTIONNELLES
          </h2>

          <div className="mb-6">
            <h3 className="text-xl font-semibold mb-3">8.1. Prix</h3>
            <div className="space-y-3">
              <p>
                <strong>8.1.1.</strong> Les prix des Produits indiqués sur la
                Plateforme s&apos;entendent toutes taxes comprises (TVA incluse)
                mais hors Frais de Livraison (les « Prix »).
              </p>
              <p>
                <strong>8.1.2.</strong> Les Frais de Livraison applicables sont
                indiqués dans le panier et sont facturés en sus du Montant de
                Commande. Les Frais de livraison peuvent être stipulés hors
                taxes ou toutes taxes comprises selon les règles applicables à
                chaque Partenaire de Livraison.
              </p>
              <p>
                <strong>8.1.3.</strong> Le prix total de la Commande est indiqué
                sur la page accessible après avoir cliqué sur le bouton « Passer
                commande ». Il comprend les Prix des Produits, les Frais de
                Livraison et les taxes applicables (le « Prix Total »).
              </p>
            </div>
          </div>

          <div className="mb-6">
            <h3 className="text-xl font-semibold mb-3">
              8.2. Modification des Prix
            </h3>
            <div className="space-y-3">
              <p>
                <strong>8.2.1.</strong> Les Prix sont susceptibles d&apos;être
                modifiés sur la Plateforme à tout moment à la discrétion des
                Restaurants Partenaires. En conséquence, X peut pratiquer une
                tarification dynamique, ce qui signifie que les Prix des
                Produits et les frais Livraison peuvent changer pendant que vous
                naviguez.
              </p>
              <p>
                <strong>8.2.2.</strong> Les changements de Prix n&apos;affectent
                pas les Commandes confirmées existantes, sauf en cas
                d&apos;erreur de Prix évidente. S&apos;il y a une erreur de Prix
                évidente, nous vous en informerons dès que possible et vous
                aurez le choix de confirmer la Commande au Prix initial ou
                d&apos;annuler la Commande sans frais et avec un remboursement
                complet de toute somme déjà payée.
              </p>
              <p>
                <strong>8.2.3.</strong> Les modifications de Prix
                n&apos;affecteront pas non plus les Commandes en cours de
                traitement et figurant dans votre panier, à condition que vous
                complétiez la Commande dans les cinq (5) minutes suivant la
                création du panier. Si vous ne terminez pas la Commande dans ce
                délai, le prix des Produits figurant dans votre panier ne sera
                plus garanti.
              </p>
            </div>
          </div>

          <div className="mb-6">
            <h3 className="text-xl font-semibold mb-3">
              8.3. Paiement du Prix
            </h3>
            <div className="space-y-3">
              <p>
                <strong>8.3.1.</strong> Le paiement du Prix est dû immédiatement
                et en intégralité au moment de la validation de la Commande au
                moyen du Moyen de Paiement choisi. Une fois la Commande validée,
                votre carte de crédit ou de débit sera autorisée et le Prix
                Total sera indiqué pour le paiement. Le paiement est effectué
                directement à X agissant pour le compte du Restaurant Partenaire
                et du Partenaire de Livraison qui exécuteront la Commande.
              </p>
              <p>
                <strong>8.3.2.</strong> Les Moyens de Paiement autorisés sont
                les cartes de paiement ou de crédit. Suivant les conditions de
                débit applicables, le débit effectif peut ne pas être immédiat
                et il appartient au Client de vérifier ses relevés.
              </p>
              <p>
                <strong>8.3.3.</strong> X est autorisée par chaque Restaurant
                Partenaire à accepter des paiements en son nom.
              </p>
              <p>
                <strong>8.3.4.</strong> Si nous ne pouvons pas débiter le Moyen
                de Paiement que vous nous avez indiqué pour le Prix Total dû,
                nous vous en informerons immédiatement par écrit et pourrons
                suspendre ou supprimer votre accès à la Plateforme jusqu&apos;à
                ce que le paiement soit effectué.
              </p>
            </div>
          </div>

          <div>
            <h3 className="text-xl font-semibold mb-3">
              8.4. Offres Promotionnelles
            </h3>
            <p>
              X et/ou les Restaurants Partenaires peuvent proposer des offres
              promotionnelles par le biais de la Plateforme. Les offres
              existantes sont visibles sur la page avec les Produits et menus du
              Restaurant Partenaire à l&apos;origine de l&apos;offre.
            </p>
          </div>
        </div>

        {/* Article 9: Obligations du Client */}
        <div className="mb-8">
          <h2 className="text-2xl font-bold mb-4">9. OBLIGATIONS DU CLIENT</h2>
          <div className="space-y-4">
            <p>
              <strong>9.1.</strong> Lorsque vous utilisez la Plateforme, vous
              devez respecter l&apos;ensemble de la législation applicable. Vous
              ne pouvez utiliser la Plateforme qu&apos;à des fins licites et
              pour lesquelles elle a été conçue, comme indiqué dans les
              présentes Conditions Générales. Vous ne devez pas faire un mauvais
              usage de la Plateforme ou tenter de commettre un acte frauduleux.
            </p>
            <p>
              <strong>9.2.</strong> Vous devez fournir des informations précises
              et complètes quand vous enregistrez un Compte et quand vous
              utilisez la Plateforme.
            </p>
            <p>
              <strong>9.3.</strong> Votre Compte est personnel. Il ne peut être
              ni loué ni partagé, sauf autorisation expresse de X. Une fois que
              vous avez créé un compte :
            </p>
            <ul className="list-disc pl-6 space-y-2">
              <li>
                vous ne pouvez pas enregistrer plus d&apos;un compte, sauf
                accord écrit contraire de notre part
              </li>
              <li>
                vous ne pouvez pas autoriser des tiers à utiliser votre Compte,
                ni transférer votre Compte à un tiers
              </li>
              <li>
                vous devez veiller à ce que les informations relatives à votre
                Compte soient exactes, complètes et à jour
              </li>
              <li>
                vous ne devez pas divulguer vos informations de connexion
                confidentielles
              </li>
              <li>
                vous devez nous informer immédiatement si vous avez des raisons
                de croire que quelqu&apos;un d&apos;autre connaît votre nom
                d&apos;utilisateur ou votre mot de passe
              </li>
            </ul>
            <p>
              <strong>9.4.</strong> Vous serez responsable du paiement de tous
              les frais pouvant être dus en raison de la fourniture de Services
              par X demandés par l&apos;intermédiaire de votre Compte.
            </p>
            <p>
              <strong>9.5.</strong> Vous ne devez pas, dans votre utilisation de
              la Plateforme, causer de nuisances, de problèmes, de désagréments
              ou de dommages matériels à X ou à toute autre personne.
            </p>
          </div>
        </div>

        {/* Article 10: Service Client */}
        <div className="mb-8">
          <h2 className="text-2xl font-bold mb-4">10. SERVICE CLIENT</h2>

          <div className="mb-4">
            <h3 className="text-xl font-semibold mb-2">10.1. Généralité</h3>
            <p>
              La satisfaction de nos Clients étant fondamentale, le service
              client X (le « Service Client ») mettra en œuvre, dans la mesure
              de ses facultés, toute action envisageable et raisonnable afin de
              satisfaire les Clients.
            </p>
            <p className="mt-2">Le Service Client est joignable :</p>
            <ul className="list-disc pl-6 mt-2">
              <li>Par courriel : contact@mail</li>
              <li>Par courrier : Adresse du Siège Social</li>
            </ul>
          </div>

          <div className="mb-4">
            <h3 className="text-xl font-semibold mb-2">
              10.2. Information sur les Commandes en cours de traitement
            </h3>
            <p>
              En cas de retard ou pour toute autre question relative à votre
              Commande, vous pouvez contacter le Service Client qui tentera de
              se rapprocher du Restaurant Partenaire afin de vous apporter toute
              satisfaction.
            </p>
          </div>

          <div className="mb-4">
            <h3 className="text-xl font-semibold mb-2">
              10.3. Intervention auprès d&apos;un Restaurant
            </h3>
            <p>
              Comme indiqué à l&apos;article 6.3, en cas de demande de
              modification d&apos;une Commande, le Service Client tentera
              d&apos;obtenir l&apos;accord du Restaurant Partenaire sur la
              modification de Commande souhaitée par le Client. Néanmoins, le
              Restaurant Partenaire reste libre de ne pas faire droit à cette
              demande pour toute Commande Lancée.
            </p>
          </div>

          <div>
            <h3 className="text-xl font-semibold mb-2">10.4. Réclamation</h3>
            <p className="mb-2">
              <strong>10.4.1.</strong> En cas de Réclamation concernant une
              Commande ou un Produit, veuillez contacter le Service Client à
              l&apos;adresse suivante : contact@mail pour nous en faire part.
            </p>
            <p>
              <strong>10.4.2.</strong> En cas de Réclamation fondée, X pourra
              procéder à l&apos;émission d&apos;un avoir.
            </p>
          </div>
        </div>

        {/* Article 11: Propriété Intellectuelle */}
        <div className="mb-8">
          <h2 className="text-2xl font-bold mb-4">
            11. PROPRIÉTÉ INTELLECTUELLE
          </h2>

          <div className="space-y-4">
            <p>
              <strong>11.1.</strong> X accorde une licence personnelle,
              non-exclusive, non-transférable et non-cessible, révocable et ne
              pouvant faire l&apos;objet d&apos;aucune sous-licence, pour
              installer et/ou utiliser la Plateforme sur votre appareil, pour
              votre seul usage et uniquement pour vous permettre d&apos;accéder
              aux informations mises à disposition au moyen de la Plateforme et
              de l&apos;utiliser. Tous les droits non expressément accordés dans
              les présentes sont réservés par X et par les concédants de licence
              de X.
            </p>
            <p>
              <strong>11.2.</strong> X réserve l&apos;intégralité des droits
              liés à la Plateforme et aux Services qui ne sont pas expressément
              accordés dans les présentes Conditions Générales.
            </p>
            <p>
              <strong>11.3.</strong> Vous ne pouvez pas accomplir (et ne pouvez
              permettre à personne d&apos;autre d&apos;accomplir) les actes
              suivants :
            </p>
            <ul className="list-disc pl-6 space-y-2">
              <li>
                concéder une licence, une sous-licence, copier, modifier,
                distribuer, créer, vendre, revendre, céder ou louer une
                quelconque partie de la plateforme de X
              </li>
              <li>
                faire de l&apos;ingénierie inverse ou tenter d&apos;extraire le
                code source de la Plateforme
              </li>
              <li>
                lancer ou faire lancer tout programme ou script dans le but de
                récupérer, d&apos;indexer, d&apos;étudier ou d&apos;extraire des
                données de quelque partie que ce soit la Plateforme ou des
                données de X
              </li>
              <li>
                utiliser, afficher ou manipuler tout droit de propriété de X
                dans un but autre que l&apos;utilisation de la Plateforme
              </li>
              <li>
                créer ou enregistrer des URL, des noms de domaine, des noms
                d&apos;applications ou des profils de médias sociaux contenant
                des éléments protégés par X
              </li>
            </ul>
          </div>
        </div>

        {/* Article 12: Données Personnelles */}
        <div className="mb-8">
          <h2 className="text-2xl font-bold mb-4">12. DONNÉES PERSONNELLES</h2>

          <div className="space-y-4">
            <p>
              <strong>12.1.</strong> Les données à caractère personnel fournies
              par le Client lors de la Commande seront collectées, traitées et
              stockées selon les dispositions de la loi Informatique et Libertés
              du 6 janvier 1978 relative à la protection des données
              personnelles et au Règlement général sur la protection des données
              (la « Règlementation »).
            </p>
            <p>
              <strong>12.2.</strong> Conformément à la Règlementation, le Client
              dispose d&apos;un droit d&apos;accès, d&apos;interrogation, de
              rectification, d&apos;effacement sur les informations qui le
              concernent, d&apos;un droit d&apos;opposition à la prospection ou
              pour motif légitime, d&apos;un droit à la limitation du traitement
              et à la portabilité, ainsi que d&apos;un droit de définir des
              directives relatives au sort de ses données à caractère personnel
              après son décès.
            </p>
            <p>
              <strong>12.3.</strong> Pour plus d&apos;informations sur le
              traitement et la protection des données à caractère personnel par
              X, le Client est invité à consulter la Politique de
              confidentialité en se rendant à l&apos;adresse suivante :{" "}
              <a
                href="https://www.X.com/politique-de-confidentialite"
                className="text-blue-600 hover:underline"
              >
                https://www.X.com/politique-de-confidentialite
              </a>
              .
            </p>
            <p>
              <strong>12.4.</strong> En cas de différend relatif au traitement
              de vos données, le Client dispose du droit de déposer une
              réclamation auprès d&apos;une autorité de contrôle.
            </p>
          </div>
        </div>

        {/* Article 13: Responsabilité */}
        <div className="mb-8">
          <h2 className="text-2xl font-bold mb-4">13. RESPONSABILITÉ</h2>

          <div className="space-y-6">
            <div>
              <h3 className="text-xl font-semibold mb-2">13.1. Généralités</h3>
              <p className="mb-2">
                <strong>13.1.1.</strong> X fournit ses Services « en l&apos;état
                » et « en fonction de la disponibilité ». En conséquence, X ne
                saurait être tenue responsable vis-à-vis de vous en ce qui
                concerne toute perte directe, indirecte, particulière et plus
                généralement tout dommage découlant de votre votre incapacité à
                utiliser nos Services.
              </p>
              <p>
                <strong>13.1.2.</strong> Le contrat de vente est conclu entre
                vous et le Restaurant Partenaire. Le Restaurant Partenaire que
                vous choisissez est un commerçant indépendant, distinct de X et
                sur lequel X n&apos;a aucun contrôle. En conséquence, la
                responsabilité de X ne saurait être engagée à ce titre.
              </p>
            </div>

            <div>
              <h3 className="text-xl font-semibold mb-2">
                13.2. Information disponible sur la Plateforme
              </h3>
              <p>
                X fait ses meilleurs efforts pour fournir une information à jour
                et exacte sur la Plateforme. Il est cependant précisé que
                l&apos;information sur la Plateforme est pour l&apos;essentiel
                transmise ou directement mise en ligne par les Restaurants
                Partenaires, et X ne peut garantir que cette information est
                correcte et à jour.
              </p>
            </div>

            <div>
              <h3 className="text-xl font-semibold mb-2">
                13.3. Information sur les allergies
              </h3>
              <p>
                Tout restaurant qui devient un Restaurant Partenaire X est tenu
                de nous communiquer toutes les informations à jour sur les
                Produits et menus proposé, notamment concernant les allergènes.
                X publie sur la Plateforme toutes les informations communiquées
                par le Restaurant Partenaire à ce sujet mais ne prend aucun
                engagement concernant le caractère complet de cette information.
                En cas d&apos;allergies alimentaires ou intolérances, veuillez
                contacter le Service Client avant de passer commande.
              </p>
            </div>

            <div>
              <h3 className="text-xl font-semibold mb-2">
                13.4. Responsabilité propre de Restaurants Partenaires
              </h3>
              <p>
                X agit en qualité d&apos;intermédiaire entre le Client et le
                Restaurant Partenaire. En conséquence, X ne garantit aucunement
                la qualité, l&apos;adéquation et/ou le caractère comestible des
                Produits fournis par le Restaurant Partenaire, ni le délai de
                préparation de la Commande par le Restaurant Partenaire.
              </p>
            </div>

            <div>
              <h3 className="text-xl font-semibold mb-2">
                13.5. Responsabilité propre des Partenaires de Livraison
              </h3>
              <p>
                X agit en qualité d&apos;intermédiaire entre le Client et le
                Partenaire de Livraison. En conséquence, X ne garantit
                aucunement le respect des Délais de Livraison.
              </p>
            </div>

            <div>
              <h3 className="text-xl font-semibold mb-2">
                13.6. Exonération de responsabilité en cas de force majeure
              </h3>
              <p>
                X décline toute responsabilité dans le cas où X est dans
                l&apos;incapacité temporaire ou permanente d&apos;exécuter
                totalement ou partiellement les Services ou que des Commandes ne
                pourraient être livrées en raison d&apos;un évènement extérieur,
                imprévisible et irrésistible constituant un cas de force majeure
                tel que défini par l&apos;article 1218 du Code civil (le « Cas
                de Force Majeure »).
              </p>
            </div>

            <div>
              <h3 className="text-xl font-semibold mb-2">
                13.7. Exonération de responsabilité en cas de force majeure
              </h3>
              <p>
                La responsabilité de X ne saurait être engagée au titre de toute
                perte de profit, perte d&apos;activité, interruption
                d&apos;activité ou perte d&apos;opportunité commerciale si le
                Client utilise la Plateforme ou les Produits à des fins
                commerciales, professionnelles ou de revente ; étant rappelé que
                l&apos;utilisation de la Plateforme est réservée aux Clients
                consommateurs non-professionnels.
              </p>
            </div>
          </div>
        </div>

        {/* Article 14: Droit applicable - Litiges */}
        <div>
          <h2 className="text-2xl font-bold mb-4">
            14. DROIT APPLICABLE – LITIGES
          </h2>

          <div className="space-y-4">
            <p>
              <strong>14.1.</strong> Les présentes Conditions Générales sont
              régies par le droit français.
            </p>
            <p>
              <strong>14.2.</strong> En cas de litige ou de réclamation liés à
              l&apos;utilisation de la Plateforme et des Services ou aux
              présentes Conditions Générales, le Client est invité à se
              rapprocher du Service Client afin de trouver une solution amiable
              en adressant un email à l&apos;adresse suivante : contact@mail.
            </p>
            <p>
              <strong>14.3.</strong> A défaut de solution amiable, X proposera
              au Client un service de médiation gratuit.
            </p>
            <p>
              <strong>14.4.</strong> Il est rappelé que le recours à la
              médiation n&apos;est possible qu&apos;à la condition que la
              réclamation n&apos;ait pas été préalablement examinée par un juge
              ou un autre médiateur, et qu&apos;elle ait déjà fait l&apos;objet
              d&apos;un recours auprès du Service Client.
            </p>
            <p>
              <strong>14.5.</strong> Il est également rappelé que la Commission
              européenne a mis en place une plateforme de résolution des litiges
              destinées à recueillir les éventuelles réclamations de
              consommateurs faisant suite à un achat en ligne afin de les
              transmettre ensuite aux médiateurs nationaux compétents. Cette
              plateforme est accessible à l&apos;adresse suivante :{" "}
              <a
                href="http://ec.europa.eu/consumers/odr/"
                className="text-blue-600 hover:underline"
              >
                http://ec.europa.eu/consumers/odr/
              </a>
              .
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default CGV;
